export const ROWS = 6;
export const COLS = 5;
export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
